export { default } from './NotificationCenter'
